import ExistingPortfolioSummary from '@master/model/kyc-form/existing-plans/ExistingPortfolioSummary'
import ExistingPortfolioV2 from '@master/model/kyc-form/existing-plans/ExistingPortfolioV2'
import { Ignore } from '@master/annotation/Ignore'
import { Pointer } from '@master/annotation/Pointer'

/**
 * The ROOT here is referring to ExistingPortfolioDTO, the reason why this is setup is because
 * 1) KYCForm.ts `setData` function will only setup ExistingPortfolioDTO (as it extends Base)
 * 2) ExistingPortfolioDTO will be responsible to setup both the declaration and summary
 *
 * This means that whatever this class needs for Pointer, the parent (ExistingPortfolioDTO) needs
 * to help setup in the parent class.
 *
 * This is a convoluted way of doing, but it solves the problem right now.
 *
 * Ideal way: The KycForm setData function is able to help setup child properties recursively even though
 * the parent extends from Base.
 */
export default class ExistingPortfolioSummaryV2 extends ExistingPortfolioSummary {
  @Ignore()
  @Pointer('ROOT', 'hasClient2')
  hasClient2?: boolean = false

  @Ignore()
  @Pointer('ROOT', 'portfolios')
  portfolios: ExistingPortfolioV2[] = null
}
